
















































































































































































































































































































































































































































































































































































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';
//@ts-ignore
import formIndicadorAdministrador from '@/components/formIndicador'

//@ts-ignore
import departamentos from '@/mixins/axios/general_departamentos'

//@ts-ignore
import mirs from '@/mixins/axios/mirs'

//@ts-ignore
import indicador_administradores from '@/mixins/axios/indicador_administradores'

//@ts-ignore
import pmd_arboles_objetivos from '@/mixins/axios/pmd_arboles_objetivos'

//@ts-ignore
import poas from '@/mixins/axios/poas'

//@ts-ignore
import dependencias from '@/mixins/axios/general_secretarias'

//@ts-ignore
import departamentos from '@/mixins/axios/general_departamentos'


//@ts-ignore
import TablePPoa from '@/components/tables/tablev1'
//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";

//import {Vuetable,VuetablePagination} from 'vuetable-2'
 import OrganizationChart from 'vue-organization-chart'
  import 'vue-organization-chart/dist/orgchart.css'
import { XlsxWorkbook, XlsxSheet, XlsxDownload } from "vue-xlsx";
  import 'vue-xlsx/dist/vue-xlsx.es'
import TableToExcel from "@linways/table-to-excel";
import jsPDF from 'jspdf'
// import jsPDF = require('jspdf') // // typescript without esModuleInterop flag
// import jsPDF from 'yworks-pdf' // using yworks fork
// import jsPDF from 'jspdf/dist/jspdf.node.debug' // for nodejs
import autoTable from 'jspdf-autotable'

import VueAxios from "vue-axios";
import axios from "axios";
@Component({
  components: {
   OrganizationChart,
   formIndicadorAdministrador,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload 
  },

  data() {

    return {
 sheetName: null,
      sheets: [{ name: "SheetOne", data: [{ Nivel: 1, Resumen:1 , Medio:1, Supuestos:0,Indicadores:0}] }],
      collection: [{ a: 1, b: 2 }],

      
editindex:'',
idserie:0,
series:[],
indicador_administradordata:null,
        causas_selec:[],
          fullcard:false,
        type:'Creacion',
        data_mir:{
          idmir:null
        },
        save:{
            text:''
        }
        
    }
   
  },
  mixins:[indicador_administradores,departamentos,dependencias,pmd_arboles_objetivos,mirs,poas],
  methods:{
 GenerarPDF(row){
      
console.log(row)
    this.$store.commit('SETINDICADORPDF',row);
    this.$router.push('/mun/general/indicadores/imprimirindicador');
      },


async onClick() {
       var sTable = document.getElementById('tablamir').innerHTML;
              await axios({
                    url: this.$store.state.baseapi+"pdf",
                    method: 'POST',
                    data:{
                      html:sTable,
                      title:"Estructura Mir"
                    },
                    responseType: 'blob'
                }).then((response) => {
                     var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                     var fileLink = document.createElement('a');

                     fileLink.href = fileURL;
                     fileLink.setAttribute('download', 'file.pdf');
                     document.body.appendChild(fileLink);

                     fileLink.click();
                });
          },
    crearpdf(){
const doc = new jsPDF()
autoTable(doc, { html: '#simpleTable1'})
doc.save('mir.pdf')
    },
    crearxlsx(){


  let table = document.querySelector("#simpleTable1");
  TableToExcel.convert(table);

    },
crearexcel(){
var tbl = document.getElementById('carlostab');
var wb = XLSX.utils.table_to_book(tbl);
},
    addSheet() {
      this.sheets.push({ name: this.sheetName, data: [...this.collection] });
      this.sheetName = null;
    },
   async CrearPoa(){

console.log(this.data_mir)


 this.$root.$emit('loading', true);
let data2={
idmir:this.data_mir.idmir,
idserie:this.idserie
};

let data= await this.CREAR_POAS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
      
if(response.hasOwnProperty('series')){
alert('mas de dos series')
this.series=response.series;
$('#modalCreatePoa').modal('show');
}else if(response.hasOwnProperty('success')){
this.series=[];
this.serie=0;
 this.$root.$emit("success", "Poa creado exitosamente.");
}  
else if(response.hasOwnProperty('exist')){
this.series=[];
this.serie=0;
 this.$root.$emit("alerta_show", "Ya fue creado un poa apartir de esta mir.");
}                  
//this.indicador_administradordata=response;
                    } else {

this.series=[];
this.serie=0;
                        //this.$root.$emit("alerta_show", "Ocurrio un error al crear poa");

                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });




    },
    openIndicador(){
$('#modalCausa').modal('show')
    },
onChangeGrl(event,type,index=0,index2=0,index3=0){
console.log('grl',event.target.value)

switch(type){
  case 't1':
  this.data_mir.data[index].medio=this.indicador_administradordata.filter(item => item.id == event.target.value)[0].unidad_medida_resultado;
  break;
  case 't2':
  this.data_mir.data[index].childs[index2].medio=this.indicador_administradordata.filter(item => item.id == event.target.value)[0].unidad_medida_resultado;
  break;
  case 't3':
  this.data_mir.data[index].childs[index2].childs[index3].medio=this.indicador_administradordata.filter(item => item.id == event.target.value)[0].unidad_medida_resultado;
  break;
}

},
onChangefin(event){
console.log('fin',this.indicador_administradordata.filter(item => item.id == event.target.value))
this.data_mir.fin.medio=(this.indicador_administradordata.filter(item => item.id == event.target.value)[0]).unidad_medida_resultado;
},
onChangeobjetivo(event){
console.log('objetivo',event.target.value)
this.data_mir.objetivo.medio=(this.indicador_administradordata.filter(item => item.id == event.target.value)[0]).unidad_medida_resultado;
},
async getDataIndicadores() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio
};

let data= await this.GET_ADMINISTRADORES(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.indicador_administradordata=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},

      getdataselect(){
          console.log(this.$store.state.mir_obj);
          
          this.data_mir=this.$store.state.mir_obj;
      },
      async getdataMir(){

console.log('satatattata trae')

let datas={
  id:this.$store.state.mir_obj.idmir
}

let data= await this.GET_MIRS(datas).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        console.log(response)
                        
this.data_mir={
    idmir:response.id,
    fin:JSON.parse(response.efecto),
    objetivo:JSON.parse(response.objetivo),
    data:JSON.parse(response.componentes),

    };
console.log(response.id)
    console.log(this.data_mir.idmir)
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar mir, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });

      }
,
 async CrearMir(){
this.$root.$emit('loading', true);


let datas={
          idarbol_objetivo:this.$store.state.arbol_problema.idobjetivos,
           
             objetivo:this.data_mir.objetivo, 
              efecto:this.data_mir.fin, 
               componentes:this.data_mir.data, 
          
     
          }
let data= await this.CREAR_MIRS(datas).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.data_mir={
    idmir:response.id,
    fin:JSON.parse(response.efecto),
    objetivo:JSON.parse(response.objetivo),
    data:JSON.parse(response.componentes),

    };
    this.$root.$emit(
            "success",
            "Mir Creada correctamente"
          );
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar mir, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$router.push('/mun/poa/arbol')
                    this.$root.$emit('loading', false);

                    //loading.close();
                });

      },
      
 async EditarMir(){
this.$root.$emit('loading', true);
let datas={
          id:this.$store.state.mir_obj.idmir,
           
             objetivo:this.data_mir.objetivo, 
              efecto:this.data_mir.fin, 
               componentes:this.data_mir.data, 
          
     
          }
let data= await this.EDITAR_MIRS(datas).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.data_mir={
    idmir:response.id,
    fin:JSON.parse(response.efecto),
    objetivo:JSON.parse(response.objetivo),
    data:JSON.parse(response.componentes),

    };
     this.$root.$emit(
            "success",
            "Mir Modificada correctamente"
          );
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar mir, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });

      },









  },
  created(){
      
  },
  mounted(){
this.getDataIndicadores();
      if(this.$route.query.type=='editar'){
            this.type='Edicion';
            //this.getPeoblema();
            this.getdataMir();
      }else{
           this.type='Creacion';
            //this.getPeoblema();
            console.log('mir obj----',this.$store.state.mir_obj);
            this.getdataselect();
      }
   
   
  }
})
export default class Home extends Vue {}

